export const payment_methods = [
    "bank-transfer",
    "cash",
    "card",
    "bank-direct-debit"
]